/** @namespace ns_.StreamingAnalytics.createPlaybackSession */
/** @namespace ns_.StreamingAnalytics.getPlaybackSession */
/** @namespace ns_.StreamingAnalytics.notifyPlay */
/** @namespace ns_.StreamingAnalytics.notifyPause */
/** @namespace ns_.StreamingAnalytics.notifyEnd */
/** @namespace ns_.PlaybackSession.setAsset */

export class ComScore
{
	constructor(s2nEventSource)
	{
		s2nEventSource.addEventListener
		(
			'message',
			e =>
			{
				if(e.data.type !== 's2nEvent')
				{
					return;
				}
				let callback = 'on'+e.data.s2nEvent[0].toUpperCase()+e.data.s2nEvent.slice(1);
				if(this[callback])
				{
					this[callback](e.data);
				}
			}
		)
	}

	// noinspection JSUnusedGlobalSymbols
	onLoad(detail)
	{
		this.assetLabels =
		{
			ns_st_ci: ''+detail.mediaId,
			ns_st_pu: ''+detail.mediaPublisher || 'SendtoNews',
			ns_st_pr: '*null',
			ns_st_ep: '*null',
			ns_st_sn: '*null',
			ns_st_en: '*null',
			ns_st_ge: 'Sports',
			ns_st_ia: '0',
			ns_st_ddt: '*null',
			ns_st_tdt:  '*null',
			ns_st_st: 'SendtoNews',
			c3: 'sendtonews',
			c4: '*null',
			c6: '*null'
		};

		this.adCuePoints = [];

		this.contentLabels =
		{
			ns_st_cl: ''+detail.mediaLength*1000,
			ns_st_ct: 'vc12',
			ns_st_pn: '1',
			ns_st_tp: '1',
			ns_st_ce: '0'
		};

		this.setContentAssetOnContentPlay = true;

		this.streamingAnalytics = new ns_.StreamingAnalytics( { publisherId: '18065638' } );
		this.streamingAnalytics.createPlaybackSession();
	}

	// noinspection JSUnusedGlobalSymbols
	onAdStart(detail)
	{
		this.setContentAssetOnContentPlay = true;

		let adPosition = null;
		let adCode = null;
		switch(detail.adPosition)
		{
			case -1:
				adPosition = 'post-roll';
				adCode = 'va13';
				break;
			case 0:
				adPosition = 'pre-roll';
				adCode = 'va11';
				break;
			default:
				adPosition = 'mid-roll';
				adCode = 'va12';
		}
		this.adCuePoints = detail.adCuePoints;
		const assetMetadata = Object.assign
		(
			{
				ns_st_cl: ''+detail.adLength*1000,
				ns_st_ad: adPosition,
				ns_st_ct: adCode
			},
			this.assetLabels
		);
		this.streamingAnalytics.getPlaybackSession().setAsset(assetMetadata);
		this.streamingAnalytics.notifyPlay(0);
	}

	// noinspection JSUnusedGlobalSymbols
	onAdPause()
	{
		this.streamingAnalytics.notifyPause();
	}

	// noinspection JSUnusedGlobalSymbols
	onAdPlay(detail)
	{
		this.setContentAssetOnContentPlay = true;
		this.streamingAnalytics.notifyPlay(detail.currentTime * 1000);
	}

	// noinspection JSUnusedGlobalSymbols
	onAdFinish()
	{
		this.streamingAnalytics.notifyEnd();
	}

	// noinspection JSUnusedGlobalSymbols
	onContentPlay(detail)
	{
		// total media segments
		// count the number of midrolls and add 1
		this.contentLabels.ns_st_tp = ''+
		(
			(this.adCuePoints || [])
			.filter
			(
				(v,i,a) =>
				// get unique values
				a.indexOf(v) === i
				// that aren't pre or post rolls
				&& v > 0
			)
			.length + 1
		);

		// current media segment
		// count the number of midrolls in the past and add 1
		this.contentLabels.ns_st_pn = ''+
		(
			(this.adCuePoints || [])
			.filter
			(
				(v,i,a) =>
				// get unique values
				a.indexOf(v) === i
				// that aren't pre or post rolls
				&& v > 0
				// that are in the past
				&& v <= detail.currentTime
			)
			.length + 1
		);

		// if the last play was not a content play, set the current asset to the content asset
		if(this.setContentAssetOnContentPlay)
		{
			this.setContentAssetOnContentPlay = false;
			const assetMetadata = Object.assign
			(
				{
				},
				this.assetLabels,
				this.contentLabels
			);

			this.streamingAnalytics.getPlaybackSession().setAsset(assetMetadata);
			this.streamingAnalytics.notifyPlay(0);
		}
		else
		{
			this.streamingAnalytics.notifyPlay(detail.currentTime * 1000);
		}

	}

	// noinspection JSUnusedGlobalSymbols
	onContentPause(detail)
	{
		if(detail.ended)
		{
			this.streamingAnalytics.notifyEnd();
		}
		else
		{
			this.streamingAnalytics.notifyPause();
		}
	}
}
